<div class="center">
  <div class="mat-headline-5"><a class="logo" href="/"></a></div>
  <div
    class="stroked-card"
    [ngClass]="{
      'email-phone-login': (email || phone) && !magicCode
    }"
    >
    @if (!email && !phone && !magicCode) {
      <ng-container *ngTemplateOutlet="CheckUserContent"></ng-container>
    }

    @if (email && !phone && !magicCode) {
      <ng-container *ngTemplateOutlet="EmailLoginContent"></ng-container>
    }

    @if (phone && !email && !magicCode) {
      <ng-container *ngTemplateOutlet="PhoneLoginContent"></ng-container>
    }

    @if (magicCode) {
      <ng-container *ngTemplateOutlet="MagicLoginLoading"></ng-container>
    }
  </div>
  @if (email && !phone && !magicCode && !magicLinkMsg && !passwordless) {
    <div
      class="forgot-label-row flex flex-row justify-start items-center gap-[10px] w-fit ml-[30px]"
      >
      <div class="primary"><a class="mat-subtitle-1 no-style" href="#">Forgot Password?</a></div>
      <div class="primary"><a (click)="resetLogin()" class="mat-subtitle-1 no-style">Wrong email?</a></div>
    </div>
  }
  <p class="legal-links mat-caption" data-testid="login-legal-links">
    <a href="https://www.sitenotesapp.com/privacy" target="_blank" rel="noopener">Privacy Policy</a> &middot;
    <a href="https://www.sitenotesapp.com/terms" target="_blank" rel="noopener">Terms of Service</a>
  </p>
</div>

<ng-template #CheckUserContent>
  <section class="header text-left">
    <div class="text-type-2">Sign in</div>
  </section>

  <form [formGroup]="checkUserForm">
    <section class="body">
      <!-- Username -->
      <section class="username-section">
        <div class="custom-label text-type-13">EMAIL / PHONE:</div>
        <mat-form-field class="form-field w-full login-field" hideRequiredMarker>
          <input data-testid="login-username-input" [errorStateMatcher]="matcher" autocomplete="off" formControlName="username" matInput type="text" />
          @if (checkUserForm.controls.username.hasError('required')) {
            <mat-error>
              This field is <strong>required</strong>
            </mat-error>
          }
          @if (checkUserForm.controls.username.hasError('error')) {
            <mat-error class="error">
              {{ checkUserForm.controls.username.errors?.error || checkUserMessage }}
            </mat-error>
          }
        </mat-form-field>
        <!-- The error wrapper is absolutely positioned in a one-line slot, so a long error would overlap the consent -->
        @if (showSmsConsent && !checkUserForm.controls.username.hasError('error')) {
          <ng-container *ngTemplateOutlet="SmsConsent"></ng-container>
        }
      </section>
      <!-- /Username -->

      <!-- Form Actions -->
      <section>
        <div class="row">
          <button data-testid="login-next-btn" (click)="checkUser()" color="primary" mat-stroked-button>Next</button>
        </div>
      </section>
      <!-- Form Actions -->
    </section>
  </form>
</ng-template>

<!-- Login via email options -->
<ng-template #EmailLoginContent>
  <section class="header text-left">
    <div class="text-type-2">Sign in</div>
  </section>

  <section class="body">
    @if (passwordless && !magicLinkMsg) {
      <section class="magic-link-msg center v-gap-10">
        <p class="text-type-11">Emailing a sign-in link to</p>
        <p>
          <strong>{{ email }}</strong>
        </p>
      </section>
    }

    @if (!magicLinkMsg && !passwordless) {
      <div>
        <form [formGroup]="loginForm">
          <!-- Password -->
          <section class="password-section">
            <div class="multi-line-label flex flex-col justify-center items-start gap-[4px]">
              <div class="text-type-13">Password</div>
              <div class="text-type-11">
                Enter password for <span class="email">{{ email }}</span>
              </div>
            </div>
            <mat-form-field class="form-field w-full password login-field" hideRequiredMarker>
              <input
                data-testid="login-password-input"
                [errorStateMatcher]="matcher"
                autocomplete="off"
                formControlName="password"
                id="password"
                matInput
                type="password"
                />
              @if (loginForm.controls.password.hasError('required')) {
                <mat-error>
                  This field is <strong>required</strong>
                </mat-error>
              }
              @if (loginForm.controls.password.hasError('error')) {
                <mat-error>
                  {{ loginForm.controls.password.errors?.error }}
                </mat-error>
              }
            </mat-form-field>
            <div
              (click)="getMagicLink()"
              class="get-magic-link text-type-9 cursor-pointer w-fit"
            [ngClass]="{
              'with-error':
                (loginForm.controls.password.hasError('error') || loginForm.controls.password.hasError('required')) &&
                (loginForm.controls.password.touched || loginForm.controls.password.dirty)
            }"
              >
              or email me a sign in link
            </div>
          </section>
          <!-- Form Actions -->
          <section>
            <div class="row">
              <button data-testid="login-signin-btn" (click)="loginWithPassword()" color="primary" mat-flat-button>Sign in</button>
            </div>
          </section>
          <!-- Form Actions -->
        </form>
      </div>
    }

    @if (magicLinkMsg) {
      <div>
        <section class="magic-link-msg center v-gap-10">
          <div class="mat-subtitle-1">Check your email!</div>
          <p class="text-type-11">We've sent a sign-in link to</p>
          <p>
            <strong>{{ email }}</strong>
          </p>
          <p class="text-type-11">Just click the link to sign in.</p>
          @if (passwordless) {
            <p class="text-type-11 passwordless-hint">
              Your account doesn't have a password yet, so we sent you a sign-in link instead.
              To sign in with a password next time, once you're signed in click your profile icon in the
              top-right corner, then the settings (gear) icon next to your name to open your profile,
              and use <strong>Set password</strong>.
            </p>
          }
        </section>
        <section>
          <div class="row">
            <button (click)="resetLogin()" color="primary" mat-stroked-button>Back</button>
          </div>
        </section>
      </div>
    }
  </section>
</ng-template>
<!-- Login via email options -->

<!-- MagicLoginLoading -->
<ng-template #MagicLoginLoading>
  <section class="header text-left">
    <div class="text-type-2">Error</div>
  </section>

  <section class="body magic-link-section">
    @if (!magicError) {
      <div class="mat-subtitle-1 center">Validating your sign-in link.</div>
    }
    @if (magicError) {
      <div class="mat-subtitle-1 error">Link is no longer valid.</div>
    }
  </section>
  <section>
    <div class="row">
      <button (click)="resetLogin()" color="primary" mat-stroked-button>Back</button>
    </div>
  </section>
</ng-template>
<!-- MagicLoginLoading -->

<!-- Login via Phone -->
<ng-template #PhoneLoginContent>
  <section class="header text-left">
    <div class="text-type-2">Verification</div>
  </section>

  <section class="body">
    <div>
      <form [formGroup]="phoneForm">
        <!-- OTP -->
        <section class="otp-section">
          <div class="multi-line-label flex flex-col justify-center items-start gap-[4px]">
            <div class="text-type-13">Enter the one time passcode we sent to your phone at {{ phone }}</div>
            <div class="text-type-11">PASSCODE</div>
          </div>
          <mat-form-field class="login-field w-full">
            <input
              data-testid="login-otp-input"
              [errorStateMatcher]="matcher"
              autocomplete="off"
              formControlName="otp"
              inputmode="numeric"
              matInput
              maxlength="6"
              type="text"
              />
            @if (phoneForm.controls.otp.hasError('required')) {
              <mat-error>
                This field is <strong>required</strong>
              </mat-error>
            }
            @if (phoneForm.controls.otp.hasError('error')) {
              <mat-error>
                {{ phoneForm.controls.otp.errors.error }}
              </mat-error>
            }
          </mat-form-field>
        </section>
        <!-- /OTP -->

        <!-- Form Actions -->
        <section>
          <div class="flex flex-row justify-center items-center w-full gap-[10px]">
            <button type="button" (click)="resetLogin()" class="w-1/2" color="primary" mat-stroked-button>Back</button>
            <button data-testid="login-submit-btn" type="submit" (click)="loginWithPhone()" class="w-1/2" color="primary" mat-flat-button>
              Sign in
            </button>
          </div>
        </section>
        <!-- Form Actions -->
      </form>
    </div>
  </section>
</ng-template>
<!-- Login via Phone -->

<!-- SMS consent (Twilio A2P 10DLC disclosure for the passcode text) -->
<ng-template #SmsConsent>
  <p class="sms-consent mat-caption" data-testid="login-sms-consent">
    Sitenotes will text a one-time passcode to this number, one message per sign-in.
    Msg &amp; data rates may apply. Reply STOP to opt out, HELP for help.
    <span class="policy-links"><a href="https://www.sitenotesapp.com/privacy" target="_blank" rel="noopener">Privacy Policy</a> &middot;
      <a href="https://www.sitenotesapp.com/terms" target="_blank" rel="noopener">Terms of Service</a></span>
  </p>
</ng-template>
